module.exports = __webpack_public_path__ + "img/cn-logo.89117c1c.png";